<ion-header no-shadow no-border>
  <ion-toolbar>
    <ion-title>Resultados</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/transportec/tickets" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="gray" *ngIf="search">
    <div class="results-header">
      <p *ngIf="search.type==='go'">De: {{search.stop.name}}</p>
      <p *ngIf="search.type==='return'">A: {{search.stop.name}}</p>
      <p hidden>A: ITESM CEM</p>
    </div>
    <div class="results-header">
      <p>Fecha: {{search.date | toDatestring:'date'}}</p>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p *ngIf="(!trips || trips.length === 0) && !loadingResults">No hay corridas para la fecha seleccionada.</p>
  <div *ngIf="(!trips || trips.length === 0) && loadingResults">
    <div class="result skeleton" *ngFor="let trip of [0,1,2,3,4,5];">
      <div class="result-content">
        <div class="result-title">
          <ion-skeleton-text class="ion-float-left" animated style="width: 50%"></ion-skeleton-text>
          <ion-skeleton-text class="ion-float-right" animated style="width: 20%"></ion-skeleton-text>
        </div>
        <div class="result-body">
          <ion-skeleton-text animated style="width: 35%"></ion-skeleton-text>
        </div>
      </div>
      <div class="arrow">
        <ion-icon name="ios-arrow-forward"></ion-icon>
      </div>
    </div>
  </div>
  <div class="result" [class.unavailable]="trip.availability<1" (click)="goSummary(trip)" *ngFor="let trip of trips;">
    <div class="result-content">
      <div class="result-title">
        <p class="ion-float-left">{{trip.starts_at | slice:0:5}}</p>
        <p class="ion-float-right">${{price | number}}</p>
      </div>
      <div class="result-body">
        <p>Disponibilidad: {{ trip.availability < 0 ? 0 : trip.availability }}</p>
      </div>
    </div>
    <div class="arrow">
      <ion-icon name="ios-arrow-forward"></ion-icon>
    </div>
  </div>
</ion-content>
